import React, { useEffect, useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import EmbedFormLogoUploader from "components/Reusable/EmbedFormLogoUploader/EmbedFormLogoUploader.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import Image from "components/Elements/Image/Image.tsx";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import {
  updateFormDescription,
  updateFormTitle,
} from "../../Helpers/ApiCalles.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { contains_heb } from "utils/hebrewOrArabicText.js";
import { useUser } from "contexts/userContext/userContext.js";
import config from "config";

const FormEditSide = ({
  pageMode,
  titleFormRef,
  titleForm,
  titleFormPlaceHolder,
  selectedForm,
  descriptionForm,
  maxLimitText,
  descriptionFormPlaceHolder,
  formImage,
  setFormImage,
  removeFormImageApi,
  descriptionFormRef,
  maxLimitTitle,
  setTitleForm,
  setDescriptionForm,
  oldTitleForm,
  oldDescriptionForm,
  userFormsList,
  setUserFormsList,
  setOldEmbedPageFormList,
  oldEmbedPageFormList,
  setIsUpdateTitleOrDescriptionForm,
  setEmbedPageFormList,
  EmbedPageFormList,
}) => {
  const { getUserData, isPremium } = useUser();
  const userData = getUserData();
  const { setModal } = useModal();
  const { getTextByKey, getDirection } = useContent();
  let multilineTextareaTitleForm = null;
  let multilineTextareaDescriptionForm = null;
  const [showTitleFormLimit, setShowTitleFormLimit] = useState(false);
  const [showDescriptionFormLimit, setShowDescriptionFormLimit] =
    useState(false);

  useEffect(() => {
    if (multilineTextareaTitleForm && pageMode === "edit") {
      if (titleForm && titleForm.length <= 10) {
        multilineTextareaTitleForm.style.height = "auto";
        multilineTextareaTitleForm.style.height =
          multilineTextareaTitleForm.style.height = 90 + "px";
      } else if (titleForm && titleForm.length > 10 && titleForm.length < 20) {
        multilineTextareaTitleForm.style.height = "auto";
        multilineTextareaTitleForm.style.height =
          multilineTextareaTitleForm.style.height = 75 + "px";
      } else {
        multilineTextareaTitleForm.style.height = "auto";
        multilineTextareaTitleForm.style.height =
          multilineTextareaTitleForm.scrollHeight + "px";
      }
    }

    if (multilineTextareaTitleForm && titleFormPlaceHolder) {
      multilineTextareaTitleForm.style.height = "auto";
      multilineTextareaTitleForm.style.height =
        multilineTextareaTitleForm.style.height = 90 + "px";
    }
  }, [
    multilineTextareaTitleForm,
    pageMode,
    titleFormPlaceHolder,
    titleForm,
    selectedForm,
  ]);

  //Update Title Form by click outside the input
  useOnClickOutside(titleFormRef, () => {
    if (pageMode === "edit") {
      if (selectedForm) {
        if (titleForm !== oldTitleForm) {
          const updateBody = {
            EmbedDynamicId: selectedForm.Embed_Dynamic_Id,
            EmbedDynamicInnerTitle: titleForm,
          };
          updateFormTitle(updateBody);

          //Update All forms List
          setIsUpdateTitleOrDescriptionForm(true);
          let updatedList = userFormsList.map((item) => {
            if (selectedForm.Embed_Dynamic_Id === item.Embed_Dynamic_Id) {
              return { ...item, Embed_Dynamic_Inner_Title: titleForm }; //gets everything that was already in item, and updates "EmbedDynamicInnerTitle"
            }
            return item; // else return unmodified item
          });
          setUserFormsList(updatedList);

          let updatedListEmbedPage = oldEmbedPageFormList.map((item) => {
            if (selectedForm.Embed_Dynamic_Id === item.EmbedPageFormId) {
              return { ...item, EmbedPageFormInnerTitle: titleForm }; //gets everything that was already in item, and updates "EmbedDynamicInnerTitle"
            }
            return item; // else return unmodified item
          });
          setOldEmbedPageFormList(updatedListEmbedPage);

          let updatedEmbedPageNewList = EmbedPageFormList.map((item) => {
            if (selectedForm.Embed_Dynamic_Id == item.EmbedPageFormId) {
              return { ...item, EmbedPageFormInnerTitle: titleForm }; //gets everything that was already in item, and updates "EmbedDynamicInnerTitle"
            }
            return item; // else return unmodified item
          });
          setEmbedPageFormList(updatedEmbedPageNewList);
        }
      }
    }
  });

  useEffect(() => {
    if (multilineTextareaDescriptionForm && pageMode === "edit") {
      multilineTextareaDescriptionForm.style.height = "auto";
      multilineTextareaDescriptionForm.style.height =
        multilineTextareaDescriptionForm.scrollHeight + "px";
    }

    if (multilineTextareaDescriptionForm && descriptionFormPlaceHolder) {
      multilineTextareaDescriptionForm.style.height = "auto";
      multilineTextareaDescriptionForm.style.height =
        multilineTextareaDescriptionForm.style.height = 60 + "px";
    }
  }, [
    multilineTextareaDescriptionForm,
    pageMode,
    descriptionFormPlaceHolder,
    selectedForm,
  ]);

  const changeTitleFormTextarea = (e) => {
    let isChnage = false;
    if (e.length <= maxLimitTitle) {
      setTitleForm(e);
      isChnage = true;
    } else {
      setTitleForm(e.substring(0, maxLimitTitle));
      isChnage = true;
    }
    if (isChnage) {
      multilineTextareaTitleForm.style.height = "auto";
      multilineTextareaTitleForm.style.height =
        multilineTextareaTitleForm.scrollHeight + "px";
    }
  };
  const changeDescriptionFormTextarea = (e) => {
    if (e.length <= maxLimitText) {
      setDescriptionForm(e);
      multilineTextareaDescriptionForm.style.height = "auto";
      multilineTextareaDescriptionForm.style.height =
        multilineTextareaDescriptionForm.scrollHeight + "px";
    } else {
      setDescriptionForm(e.substring(0, maxLimitText));
      multilineTextareaDescriptionForm.style.height = "auto";
      multilineTextareaDescriptionForm.style.height =
        multilineTextareaDescriptionForm.scrollHeight + "px";
    }
  };

  //Update Description Form by click outside the input
  useOnClickOutside(descriptionFormRef, () => {
    if (pageMode === "edit") {
      if (selectedForm) {
        if (descriptionForm !== oldDescriptionForm) {
          const updateBody = {
            EmbedDynamicId: selectedForm.Embed_Dynamic_Id,
            EmbedDynamicFormDescription: descriptionForm,
          };
          updateFormDescription(updateBody);

          //Update All forms List
          setIsUpdateTitleOrDescriptionForm(true);
          let updatedList = userFormsList.map((item) => {
            if (selectedForm.Embed_Dynamic_Id === item.Embed_Dynamic_Id) {
              return { ...item, Embed_Dynamic_Description: descriptionForm }; //gets everything that was already in item, and updates "EmbedDynamicInnerTitle"
            }
            return item; // else return unmodified item
          });
          setUserFormsList(updatedList);

          let updatedListEmbedPage = oldEmbedPageFormList.map((item) => {
            if (selectedForm.Embed_Dynamic_Id === item.EmbedPageFormId) {
              return { ...item, EmbedPageFormDescription: descriptionForm }; //gets everything that was already in item, and updates "EmbedDynamicInnerTitle"
            }
            return item; // else return unmodified item
          });
          setOldEmbedPageFormList(updatedListEmbedPage);

          let updatedEmbedPageNewList = EmbedPageFormList.map((item) => {
            if (selectedForm.Embed_Dynamic_Id == item.EmbedPageFormId) {
              return { ...item, EmbedPageFormDescription: descriptionForm }; //gets everything that was already in item, and updates "EmbedDynamicInnerTitle"
            }
            return item; // else return unmodified item
          });
          setEmbedPageFormList(updatedEmbedPageNewList);
        }
      }
    }
  });

  useEffect(() => {
    if (multilineTextareaDescriptionForm && pageMode === "edit") {
      multilineTextareaDescriptionForm.style.height = "auto";
      multilineTextareaDescriptionForm.style.height =
        multilineTextareaDescriptionForm.scrollHeight + "px";
    }

    if (multilineTextareaDescriptionForm && descriptionFormPlaceHolder) {
      multilineTextareaDescriptionForm.style.height = "auto";
      multilineTextareaDescriptionForm.style.height =
        multilineTextareaDescriptionForm.style.height = 60 + "px";
    }
  }, [
    multilineTextareaDescriptionForm,
    pageMode,
    descriptionFormPlaceHolder,
    selectedForm,
  ]);

  const saveFormImage = (e) => {
    if (formImage && e) {
      setIsUpdateTitleOrDescriptionForm(true);
      //update the image of the form in oldEmbedPageFormList and userFormsList
      let updatedList = userFormsList.map((item) => {
        if (selectedForm.Embed_Dynamic_Id === item.Embed_Dynamic_Id) {
          return { ...item, Embed_Dynamic_Image_Url: e.path }; //gets everything that was already in item, and updates "EmbedDynamicInnerTitle"
        }
        return item; // else return unmodified item
      });
      setUserFormsList(updatedList);

      let updatedListEmbedPage = oldEmbedPageFormList.map((item) => {
        if (selectedForm.Embed_Dynamic_Id === item.EmbedPageFormId) {
          return { ...item, EmbedPageFormImage: e.path }; //gets everything that was already in item, and updates "EmbedDynamicInnerTitle"
        }
        return item; // else return unmodified item
      });
      setOldEmbedPageFormList(updatedListEmbedPage);

      let updatedEmbedPageNewList = EmbedPageFormList.map((item) => {
        if (selectedForm.Embed_Dynamic_Id == item.EmbedPageFormId) {
          return { ...item, EmbedPageFormImage: e.path }; //gets everything that was already in item, and updates "EmbedDynamicInnerTitle"
        }
        return item; // else return unmodified item
      });
      setEmbedPageFormList(updatedEmbedPageNewList);
    }
  };

  return (
    <>
      <div className="title-form" ref={titleFormRef}>
        <>
          {pageMode !== "edit" ? (
            titleForm && (
              <h2
                //dir="auto"
                className={`${
                  titleForm.length > 26
                    ? "above26"
                    : titleForm.length > 14
                    ? "above20"
                    : titleForm.length > 12
                    ? "above15"
                    : titleForm.length > 10
                    ? "above10"
                    : ""
                }`}
              >
                {titleForm}
              </h2>
            )
          ) : (
            <div className="title-form-input">
              <input
                style={{ direction: contains_heb(titleForm) }}
                onFocus={() => setShowTitleFormLimit(true)}
                onBlur={() => setShowTitleFormLimit(false)}
                //dir="auto"
                className={`titleFormTextArea ${
                  titleForm.length > 26
                    ? "above26"
                    : titleForm.length > 14
                    ? "above20"
                    : titleForm.length > 12
                    ? "above15"
                    : titleForm.length > 10
                    ? "above10"
                    : ""
                } ${titleFormPlaceHolder ? "empty-title" : ""} ${
                  titleForm.length >= 30 ? "max-limit" : ""
                }`}
                ref={(ref) => (multilineTextareaTitleForm = ref)}
                onChange={(e) => changeTitleFormTextarea(e.target.value)}
                value={titleForm}
                type="text"
                placeholder={
                  titleFormPlaceHolder ? titleFormPlaceHolder : titleForm
                }
              />
              {showTitleFormLimit && (
                <div
                  className="max-chars"
                  style={{ direction: contains_heb(titleForm) }}
                >
                  <span className="show-chars" style={{ direction: "ltr" }}>
                    {titleForm.length} / {maxLimitTitle}
                  </span>
                </div>
              )}
            </div>
          )}
        </>
      </div>
      {formImage ? (
        <div
          className="form-image"
          onClick={() =>
            setModal(() =>
              isPremium() ? (
                <EmbedFormLogoUploader
                  formId={selectedForm && selectedForm.Embed_Dynamic_Id}
                  logoImage={formImage}
                  setLogoImage={setFormImage}
                  removeImageApi={removeFormImageApi}
                  saveFormImage={saveFormImage}
                  type="personalPage"
                />
              ) : (
                <EmbedLimitOptionsModal />
              )
            )
          }
        >
          <div className="upload-div-image">
            <div className="upload-div-image-container">
              <Icon src={`${config.api.resource}/assets/images/personal/upload-image-button.svg`} />
              <span>{getTextByKey("personal-pages-upload-image-button")}</span>
            </div>
          </div>
          <Image src={formImage} alt="" title="" />
        </div>
      ) : (
        <div
          className={`form-image empty-image`}
          onClick={() =>
            setModal(() =>
              isPremium() ? (
                <EmbedFormLogoUploader
                  formId={selectedForm && selectedForm.Embed_Dynamic_Id}
                  logoImage={formImage}
                  setLogoImage={setFormImage}
                  removeImageApi={removeFormImageApi}
                  saveFormImage={saveFormImage}
                  type="personalPage"
                />
              ) : (
                <EmbedLimitOptionsModal />
              )
            )
          }
        >
          <div className="upload-div-image">
            <div className="upload-div-image-container">
              <Icon
                src={
                  `${config.api.resource}/assets/images/personal/upload-image-button.svg`
                }
              />
              <span>{getTextByKey("personal-pages-upload-image-button")}</span>
            </div>
          </div>
        </div>
      )}
      <div className="form-description" ref={descriptionFormRef}>
        <div className="description-form-textarea">
          <textarea
            style={{
              direction: descriptionForm
                ? contains_heb(descriptionForm)
                : getDirection(),
            }}
            onFocus={() => setShowDescriptionFormLimit(true)}
            onBlur={() => setShowDescriptionFormLimit(false)}
            //dir="auto"
            className={`${descriptionFormPlaceHolder ? "empty-text" : ""} ${
              descriptionForm.length >= 150 ? "max-limit" : ""
            }`}
            ref={(ref) => (multilineTextareaDescriptionForm = ref)}
            //rows={4}
            onChange={(e) => changeDescriptionFormTextarea(e.target.value)}
            value={descriptionForm}
            placeholder={
              descriptionFormPlaceHolder
                ? descriptionFormPlaceHolder
                : descriptionForm
            }
          />
          {showDescriptionFormLimit && (
            <div
              className="max-chars"
              style={{ direction: contains_heb(descriptionForm) }}
            >
              <span className="show-chars" style={{ direction: "ltr" }}>
                {descriptionForm.length} / {maxLimitText}
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FormEditSide;
